import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { IoWalletOutline } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { IoPersonOutline } from "react-icons/io5";
import { MdNewspaper } from "react-icons/md";
import { GiShoppingBag } from "react-icons/gi";
import './Navbar.scss';

function Navbar() {
  const location = useLocation();

  // Function to check if the path should be active
  const checkActive = (path, match, location) => {
    // Add all paths that should activate this NavLink
    if (path === "/Groupe" || path === "/Rassemble") {
      return location.pathname === path || location.pathname === "/Rassemble";
    }
    if (path === "/CopyMain" || path === "/Sommet") {
      return location.pathname === path || location.pathname === "/Sommet";
    }
    return match;
  };

  return (
    <nav className="navbar">
      <NavLink to="/Details" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
      <IoWalletOutline className="icon" />
        <span>Orders</span>
      </NavLink>
      {/* Use the checkActive function for the "Sell" NavLink */}
      <NavLink to="/Groupe" className={({ isActive }) => 
          checkActive("/Groupe", isActive, location) ? 'nav-item active' : 'nav-item'}
      >
        <GiShoppingBag className="icon" />
        <span>Sell</span>
      </NavLink>
      <NavLink to="/News" className={({ isActive }) => 
          checkActive("/News", isActive, location) ? 'nav-item active' : 'nav-item'}
      >
        <MdNewspaper className="icon" />
        <span>News</span>
      </NavLink>
      <NavLink to="/CopyMain" className={({ isActive }) => 
          checkActive("/CopyMain", isActive, location) ? 'nav-item active' : 'nav-item'}
      >
        <GiNotebook className="icon" />
        <span>History</span>
      </NavLink>
      <NavLink to="/" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
        <IoPersonOutline className="icon" />
        <span>Personal</span>
      </NavLink>
    </nav>
  );
}

export default Navbar;
